const infinityScroll = {
    props: {
        loading:{
            type: Boolean,
            default: true
        },
        hasMore: {
            type: Boolean,
            default: true
        }
    },
    template: 
    `<div>
        <transition name="fade">
            <div v-if="loading" class="circle-loader"></div>
        </transition>
    </div>`,
    data: function () {
		return {
        }
    },
    mounted(){

        jQuery(window).on('scroll.infinity', (e)=> {
            this.handleScroll()
        })
    },
    beforeUnmount: function () {
        jQuery(window).off('scroll.infinity')
    },
    methods:{
        handleScroll(e){
            let element = this.$el
			if ( element.getBoundingClientRect().bottom < window.innerHeight && element.getBoundingClientRect().bottom>0) {
                if(!this.loading && this.hasMore){
                    this.$emit("onloadMore")
                }
			}
        }
    }
}
